<ion-toolbar class="main-header-toolbar">
    <app-header></app-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content" *transloco="let t; read: 'loyaltyProgram'">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100" (ionRefresh)="refresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <!--refresher end-->

    <ion-grid fixed class="grid-md">

        <ion-row class="white-bg-wrapper">
            <ion-col size="12" class="ion-justify-content-start">
                <div class="top-wrapper">
                    <div class="back" [routerLink]="'/home'">
                        <img alt="back" src="assets/images/icons/arrow_left_green.svg"/>
                        {{ 'btnBack'|transloco }}
                    </div>

                    <div class="page-title">
                        {{ t('title') }}
                    </div>
                    <div class="light-yellow-background saved-wrapper ion-margin-bottom">

                        <div class="img">
                            <img alt="coins" src="assets/images/programs/pig.png"/>
                        </div>
                        <div>
                            <div class="save-title"> {{ t('saved') }}</div>
                            <div class="amount">{{ balanceInfo?.balance ? balanceInfo?.balance : '0' }} {{ t('grn') }}</div>

                        </div>
                    </div>


                    <ion-accordion-group *ngIf="this.showBalanceHistory" class="bonuses-history-wrapper">
                        <ion-accordion value="first">
                            <ion-item slot="header" class="bonuses-history">
                                <ion-label> {{ t('bonusesHistory') }}</ion-label>
                            </ion-item>
                            <div class="ion-padding bonus-item"
                                 [ngClass]="{'terminated':payment.expiredAt === 'expired' && payment.side === 1}" slot="content"
                                 *ngFor="let payment of this.balanceInfo?.awards">
                                <div class="start">
                                    <img alt="coins"
                                         src="../../../assets/images/icons/{{payment.side === 1  || payment.side === 3 ? 'accrued_arrow' :'withdrawn_arrow'}}.svg"/>
                                    <div class="info">
                                        <div>{{ t(payment.titleType) }}</div>
                                        <div class="term"
                                             *ngIf="payment.expiredAt && payment.side != 2">{{ t('period') }} {{ payment.expiredAt === 'expired' ? t('expired') : payment.expiredAt }}
                                        </div>
                                        <div class="term"
                                             *ngIf="payment.titleType === 'referralProgram'">{{ t('for') }} {{ payment.assignedStudent }}
                                        </div>

                                    </div>

                                </div>
                                <div class="end">

                                    <div class="amount">{{ payment.amount }} {{t('grn')}}</div>
                                    <div class="info">
                                        <div class="action"
                                             [ngClass]="{'green':payment.side === 1 || payment.side === 3, 'yellow':payment.side === 2}">{{ (payment.side === 1 || payment.side === 3) ? t('accrued') : t('withdraw') }}
                                        </div>
                                        <div class="date">{{ payment.createdAt }}</div>
                                    </div>

                                </div>
                            </div>

                            <!--              <div class="ion-padding bonus-item terminated" slot="content">-->
                            <!--                <div class="start">-->
                            <!--                  <img alt="coins" src="../../../assets/images/icons/terminated_arrow.svg"/>-->
                            <!--                  <div class="info">-->
                            <!--                    <div>Сертифікати</div>-->
                            <!--                    <div class="term">термін дії: протерміновано</div>-->

                            <!--                  </div>-->
                            <!--                </div>-->
                            <!--                <div class="end">-->

                            <!--                  <div class="amount">1000 грн</div>-->
                            <!--                  <div class="info">-->
                            <!--                    <div class="action green">{{ t('accrued') }}</div>-->
                            <!--                    <div class="date">30.12.2024</div>-->
                            <!--                  </div>-->

                            <!--                </div>-->
                            <!--              </div>-->
                        </ion-accordion>
                    </ion-accordion-group>


                </div>


            </ion-col>

        </ion-row>

        <div class="programs-wrapper ion-padding-top">

            <app-program-item [title]=" t('referralProgram') " [share]="true" [type]="'referral_program'"
                              [refUrl]="balanceInfo?.refUrl"></app-program-item>

            <app-program-item [title]=" t('bonusesProgram') " [share]="false"
                              [type]="'bonus_program'"></app-program-item>
        </div>

        <div class="programs-wrapper ion-padding-top">

            <app-program-item [title]="t('cashbackProgram')" [share]="false"
                              [type]="'cashback_program'"></app-program-item>

        </div>





    </ion-grid>
    <app-footer></app-footer>

</ion-content>
<app-chats></app-chats>
